// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"635d2d14","455":"25e3b54e","977":"d48c7825"}[chunkId] + ".chunk.js";
};